import * as RadixSeparator from "@radix-ui/react-separator";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { cn } from "@/shared/lib/cn";

export const Separator = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof RadixSeparator.Root>
>(({ className, orientation = "horizontal", decorative = true, ...p }, ref) => (
  <RadixSeparator.Root
    ref={ref}
    orientation={orientation}
    decorative={decorative}
    className={cn(
      "bg-[var(--separator)]",
      orientation === "horizontal" ? "h-px w-full" : "w-px h-full",
      className,
    )}
    {...p}
  />
));
Separator.displayName = "Separator";
